import { Contact } from '../@types/Contact';
import { RequestApi } from '../helpers';

const createContactUsMessage = async (contactUs: Contact) => {
  const response = await RequestApi.post<Contact>(`/contactus`, contactUs);
  return response;
};

const contactUsService = {
  createContactUsMessage,
};

export default contactUsService;
